<template>
	<div
		v-if="isVisibleOnFeatureSwitch"
		:class="[
			'btn-action-ribbon-split',
			expanded && 'is-open',
			(disabled || isLoading || hasLoaded) && 'is-disabled',
			isLoading && 'is-loading',
			hasLoaded && 'has-loaded'
		]"
		ref="popperReference"
	>
		<div class="btn-action-ribbon-split__btn-container">
			<ButtonActionRibbon
				:variant="variant"
				:labelText="labelText"
				:iconClassName="iconClassName"
				:hasUnsavedChanges="hasUnsavedChanges"
				@click="defaultActionHandler"
			/>
			<BtnTrigger
				class="btn-action-ribbon-split__trigger"
				@click="toggleDropdownVisibility"
				:expanded="expanded"
			/>
		</div>
		<PopperPosition
			trackedRefName="popperReference"
			popoverRefName="popper"
			placement="bottom-start"
			:popperVisible="expanded"
			strategy="fixed"
			@popperMinWidthChanged="setpopperMinWidth"
		/>
		<Menu
			:options="options"
			:visible="expanded"
			:minWidth="popperMinWidth"
			@change="dropdownOptionSelected"
			ref="popper"
		/>
		<ButtonProgress
			:isLoading="isLoading"
			:hasLoaded="hasLoaded"
			:hasError="hasError"
			:errorMessage="errorMessage"
			:isActionRibbon="true"
		/>
	</div>
</template>

<script>
import baseComponentMixin from '@/mixins/base-component-mixin';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import baseButtonMixin from '@/mixins/base-button-mixin';
import buttonSplitMixin from '@/mixins/button-split-mixin';
import ButtonActionRibbon from './button-action-ribbon.vue';
import BtnTrigger from '@/components/forms/shared-stateless-elements/btn-trigger.vue';
import Menu from '../menu/menu.vue';
import ButtonProgress from '@/components/visual/loader/button-progress.vue';
import PopperPosition from '@/components/visual/popper-position/popper-position.vue';

export default {
	name: 'ButtonActionRibbonSplit',
	mixins: [
		baseComponentMixin,
		baseButtonMixin,
		buttonSplitMixin,
		componentVariantMixin
	],
	components: {
		ButtonActionRibbon,
		BtnTrigger,
		ButtonProgress,
		Menu,
		PopperPosition
	},
	props: {
		hasUnsavedChanges: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.btn-action-ribbon-split {
	display: inline-block;
	position: relative;

	&:deep(.btn-action-ribbon) {
		padding: $btn-padding-y $btn-padding-x;
		border-bottom-right-radius: 0px;
		border-top-right-radius: 0px;

		// to increase specificity
		&:first-child {
			border-right: none;
		}
	}

	&__btn-container {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__trigger {
		&:hover,
		&:focus,
		&:active {
			color: var(--bg-brand-2-tint-fg-2);
			background: var(--bg-brand-2-tint);
		}
	}
}

/* LL styles v1 Only */
.btn-action-ribbon-split {
	&__trigger {
		color: var(--bg-2-fg-3);
		border: $btn-border-width solid var(--neutral-5);
	}

	&:deep(.btn-action-ribbon) {
		border: $btn-border-width solid var(--neutral-5);
	}
}

/* LL styles v2 Only */
/* .btn-action-ribbon-split {
	&__trigger {
		color: var(--bg-brand-2-fg-2);
		border: $btn-border-width solid var(--neutral-0);
	}

	&:deep(.btn-action-ribbon) {
		border: $btn-border-width solid var(--neutral-0);
		.btn-action-ribbon {
			&:hover {
				.btn-action-ribbon__label {
					border-color: var(--bg-brand-2-fg-2);
				}
			}
		}
	}
} */
</style>
